/**
 * "Kim jestes w tej rozmowie": wybor mowcy, ktorego dotyczy wynik zwyklego uzytkownika. Wspolne dla serwera i klienta.
 * Wylacznie stale i typy, bez DOM i bez API Node.
 *
 * Wybor trzyma `AnalysisSession.userSpeakerId` (Speaker.id tej samej analizy albo null). Ustawia go albo formularz
 * wgrywania (tylko tekst Z PODPISAMI: pole `selfSpeaker`, nazwa mowcy z podgladu rozpoznania), albo ekran wyniku
 * (PUT /api/sessions/:id/ja), bo przy nagraniu i tekscie bez podpisow mowcow znamy dopiero po przetworzeniu.
 *
 * Odczyt: `userSpeakerId` jest w GET /api/sessions/:id i w wierszach GET /api/sessions, dla obu kont. W szczegole serwer
 * oddaje albo id mowcy z `speakers[]` tej analizy, albo null (id mowcy, ktorego juz nie ma, to brak wyboru); na liscie
 * wartosc jest surowa. Pole formularza `selfSpeaker` serwer dopasowuje do mowcy tylko przy tekscie z podpisami, a brak
 * dopasowania nie jest bledem (wybor zostaje na ekranie wyniku).
 */

/** Pole formularza wgrywania (multipart): nazwa mowcy z tekstu z podpisami, ktory jest uzytkownikiem. */
export const POLE_MOWCA_UZYTKOWNIKA = "selfSpeaker";

/** Najdluzsza nazwa mowcy przyjmowana w tym polu (w znakach). */
export const MAX_ZNAKOW_POLA_MOWCY_UZYTKOWNIKA = 200;

/** PUT /api/sessions/:id/ja. `null` zdejmuje wybor. */
export interface ZapisMowcyUzytkownikaDto {
  speakerId: string | null;
}

/** Odpowiedz PUT /api/sessions/:id/ja. */
export interface OdpowiedzMowcyUzytkownikaDto {
  userSpeakerId: string | null;
}

/**
 * Kody bledow PUT /api/sessions/:id/ja (pole `error`):
 * 404 nie_ma_takiej_sesji (tez cudza analiza), 404 nie_ma_takiego_mowcy (mowca spoza tej analizy), 400 zly_parametr.
 */
export const KODY_BLEDOW_MOWCY_UZYTKOWNIKA = ["nie_ma_takiej_sesji", "nie_ma_takiego_mowcy", "zly_parametr"] as const;
